import React from "react";

function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="split split--narrow-left">
          <div>
            <p className="eyebrow">Our story</p>
            <h2>An RAF lodge with an open door.</h2>
          </div>
          <div>
            <p className="lede">
              Warwickshire Royal Air Force Lodge 9456 started when a group of Masons who
              were RAF veterans got together for a Sunday lunch.
            </p>
            <p>
              After two years, in 1992, it was Consecrated as a Freemason's Lodge under
              the banner of the United Grand Lodge of England. We are the only RAF
              Freemason's Lodge in the country to accept all RAF ranks, as well as those
              interested in the RAF. Our founder members included four DFC medal holders,
              Battle of Britain Spitfire pilots, dam buster raid airmen, airmen who were
              involved in the sinking of Germany's pocket battleship, <em>Tirpitz</em>,
              and pilots who had been shot down but escaped the Nazis so that they could
              return to their Squadrons.
            </p>
            <p>
              Originally a fully peripatetic, travelling Lodge, the members enjoyed
              weekends away on bases, meeting up with old pals. The wives of the Brethren
              would accompany them, and there was a vibrant social life.
            </p>
            <p>
              Today, the Lodge carries on the traditions of the founders, with visits to
              bases and an RAF centric culture which boasts the camaraderie of the RAF
              together with a unique RAF identity and spirit.
            </p>
            <blockquote className="pullquote">
              You don't have to be an RAF veteran to join us — only to share an interest
              in aviation.
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
